import React from 'react'
import Grid from '@material-ui/core/Grid'
import { StyledAddressDiv, CustomH5 } from '../../theme/Global'
import { renderAddress } from '../helpers'

const LocationAddress = ({ location }) => {
  return (
    <Grid item xs={12}>
      <CustomH5>Location Address</CustomH5>
      <StyledAddressDiv>
        {renderAddress(location.address)}
      </StyledAddressDiv>
    </Grid>
  )
}

export default LocationAddress
